// MeowMate — JS cho gallery + buy box + cart drawer
// Trích từ au.js của Auraback. Idempotent, nạp bằng defer.
// Đã bỏ: menu burger, slider before/after, count-up, parallax, thanh tiến độ đọc,
//        histogram đánh giá, lightbox ảnh review (thuộc các section không mang sang).

  // ===== Khởi tạo, reveal, đồng hồ, đổi variant, gallery, thanh sticky, cart drawer  [nguồn au.js 2-281] =====
(function () {
  if (window.__auInit) return;
  window.__auInit = true;

  // Reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // Countdown: đếm về nửa đêm (urgency bar) — 3 ô giờ/phút/giây, fallback chuỗi 1 dòng
  if (document.querySelector('[data-cd-h],[data-au-countdown],[data-au-clock]')) {
    var pad2 = function (n) { return String(n).padStart(2, '0'); };
    var cdFill = function (sel, val) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) { el.textContent = val; });
    };
    var tick = function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.floor((end - now) / 1000);
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      cdFill('[data-cd-h]', pad2(h));
      cdFill('[data-cd-m]', pad2(m));
      cdFill('[data-cd-s]', pad2(s));
      cdFill('[data-au-countdown]', h + 'H ' + pad2(m) + 'M ' + pad2(s) + 'S');
      cdFill('[data-au-clock]', pad2(h) + ':' + pad2(m) + ':' + pad2(s));
    };
    tick(); setInterval(tick, 1000);
  }

  // Bộ chọn biến thể: gói bán (mua 1 / 2 / 3) × màu.
  // Giá, giá gạch, SAVE%, giá mỗi cái đều lấy từ biến thể THẬT của Shopify,
  // nên không bao giờ lệch với giỏ hàng và trang thanh toán.
  (function () {
    var box = document.querySelector('[data-au-variants]');
    var confEl = document.querySelector('[data-au-vconf]');
    if (!box || !confEl) return;
    var VS, CF;
    try { VS = JSON.parse(box.textContent); CF = JSON.parse(confEl.textContent); } catch (e) { return; }
    if (!VS.length) return;

    var vidInput = document.querySelector('[data-au-vid-input]');
    var tiers = Array.prototype.slice.call(document.querySelectorAll('[data-au-tier]'));
    var colors = Array.prototype.slice.call(document.querySelectorAll('[data-au-variant]'));
    var cta = document.querySelector('.atc-cta');

    var start = VS.filter(function (v) { return vidInput && String(v.id) === String(vidInput.value); })[0] || VS[0];
    var sel = start.o.slice();   // giá trị option đang chọn, đúng thứ tự option của sản phẩm

    function kv(i, val) { var o = {}; o[i] = val; return o; }
    function txt(root, q, s) { var el = root.querySelector(q); if (el) el.textContent = s; }
    function show(el, on, s) { if (!el) return; el.style.display = on ? '' : 'none'; if (on && s != null) el.textContent = s; }
    function pct(v) { return v.c > v.p ? Math.round((v.c - v.p) * 100 / v.c) : 0; }

    // Tìm biến thể khớp lựa chọn hiện tại; over = ghi đè tạm một option (dùng cho thẻ gói)
    function match(over) {
      var want = sel.slice();
      if (over) Object.keys(over).forEach(function (k) { want[k] = over[k]; });
      var hit = VS.filter(function (v) {
        return want.every(function (val, i) { return val == null || v.o[i] === val; });
      });
      return hit.filter(function (v) { return v.a; })[0] || hit[0] || null;   // ưu tiên cái còn hàng
    }

    function paint() {
      var v = match();
      if (!v) return;
      sel = v.o.slice();
      if (vidInput) vidInput.value = v.id;

      document.querySelectorAll('[data-au-price]').forEach(function (el) { el.textContent = v.pf; });
      document.querySelectorAll('[data-au-compare]').forEach(function (el) { show(el, !!v.cf, v.cf); });
      var sp = pct(v);
      document.querySelectorAll('.atc-price .save, .pdp-sticky-price .save').forEach(function (el) {
        show(el, sp > 0, sp > 0 ? 'SAVE ' + sp + '%' : null);
      });
      if (cta) { cta.disabled = !v.a; cta.textContent = v.a ? CF.atc : CF.sold; }

      // Thẻ gói: giá đổi theo màu đang chọn, đánh dấu thẻ đang chọn
      tiers.forEach(function (t) {
        var tv = CF.t >= 0 ? match(kv(CF.t, t.dataset.val)) : null;
        if (tv) {
          txt(t, '[data-tier-price]', tv.pf);
          show(t.querySelector('[data-tier-compare]'), !!tv.cf, tv.cf);
          var e = t.querySelector('[data-tier-each]');
          if (e) e.textContent = tv.ef + ' ' + CF.each;
          var q = pct(tv);
          // nhãn tiết kiệm nhận cả 2 token: %s = tiền ("You save $55.08"), %d = phần trăm
          show(t.querySelector('[data-tier-save]'), q > 0, q > 0 ? CF.save.replace('%s', tv.sf || '').replace('%d', q) : null);
          if (tv.a) t.removeAttribute('data-soldout'); else t.setAttribute('data-soldout', '');
        }
        var on = CF.t >= 0 && sel[CF.t] === t.dataset.val;
        t.classList.toggle('active', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      colors.forEach(function (c) {
        var on = CF.o >= 0 && sel[CF.o] === c.dataset.val;
        c.classList.toggle('active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      document.dispatchEvent(new CustomEvent('au:variant', { detail: { id: v.id } }));
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { if (CF.t >= 0) { sel[CF.t] = t.dataset.val; paint(); } });
    });
    colors.forEach(function (c) {
      c.addEventListener('click', function () { if (CF.o >= 0) { sel[CF.o] = c.dataset.val; paint(); } });
    });
    paint();
  })();

  // Gallery: slide-based (ảnh + video) — đổi slide active; fallback swap ảnh nếu dùng product.media
  var slides = Array.prototype.slice.call(document.querySelectorAll('.gallery-stage [data-au-slide]'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs .ph, .thumbs [data-au-thumb]'));
  var mainImg = document.querySelector('[data-au-main-img]');
  var mainPh = document.querySelector('[data-au-main-ph]');
  thumbs.forEach(function (t) { if (t.dataset.src) { var im = new Image(); im.src = t.dataset.src; } });
  function pauseSlide(s) {
    var v = s.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
    var f = s.querySelector('iframe'); if (f) { f.src = f.src; }
  }
  function selectThumb(i) {
    if (!thumbs.length) return;
    var idx = (i + thumbs.length) % thumbs.length;
    thumbs.forEach(function (x) { x.classList.remove('active'); });
    thumbs[idx].classList.add('active');
    thumbs[idx].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    if (slides.length) {
      slides.forEach(function (s, k) {
        if (k === idx) { s.classList.add('active'); }
        else { if (s.classList.contains('active')) pauseSlide(s); s.classList.remove('active'); }
      });
    } else if (mainImg && thumbs[idx].dataset.src && mainImg.src !== thumbs[idx].dataset.src) {
      mainImg.classList.add('fading');
      (function (src) {
        setTimeout(function () {
          var done = function () { mainImg.classList.remove('fading'); mainImg.removeEventListener('load', done); };
          mainImg.addEventListener('load', done);
          mainImg.src = src;
          if (mainImg.complete) done();
        }, 130);
      })(thumbs[idx].dataset.src);
    }
    if (mainPh) mainPh.textContent = 'Ảnh chính #' + (idx + 1);
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { selectThumb(i); }); });
  document.querySelectorAll('.thumb-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cur = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      selectThumb(cur + Number(btn.dataset.dir));
    });
  });

  // Sticky bar: hiện khi cuộn qua buy box; nút sticky submit form thật
  var sticky = document.getElementById('pdpSticky');
  var buybox = document.getElementById('buybox');
  if (sticky && buybox) {
    var watch = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    });
    watch.observe(buybox);
    var stickyBtn = document.querySelector('[data-au-sticky-atc]');
    var form = document.getElementById('au-atc-form');
    if (stickyBtn && form) stickyBtn.addEventListener('click', function () { form.requestSubmit(); });
  }

  // ===== Cart drawer (kiểu Ironless): AJAX add → mở drawer, qty chỉnh trong drawer =====
  function auLocalePath(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path.replace(/^\//, ''); }
  function auLang(en, es) { return document.documentElement.lang.split('-')[0] === 'es' ? es : en; }
  var auDrawer = document.getElementById('au-drawer');
  var auDrawerOv = document.getElementById('au-drawer-ov');
  var auFlashKeys = [];      // key các item vừa thêm → flash trong drawer
  var auPrevCount = null;    // đếm cũ → badge bounce khi tăng

  // Nhãn nút nằm trong span con (.dw-btntxt / .dwa-qtxt / .dwh-qtxt). CHỈ đổi chữ ở span đó:
  // ghi thẳng vào nút sẽ xoá .dw-fill nên hiệu ứng nền trượt chết cho tới khi tải lại trang,
  // và SVG không có width/height sẽ tràn ra ngoài nút tròn 40px của thẻ sản phẩm.
  function auLabelOf(btn) {
    return btn.querySelector('.dw-btntxt, .dwa-qtxt, .dwh-qtxt') || btn;
  }

  function auShowTick(btn) {
    btn.disabled = true;
    btn.classList.add('au-added');
    auLabelOf(btn).textContent = auLang('ADDED', 'AÑADIDO');
  }

  function auMoney(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (window.__auLastCart && window.__auLastCart.currency) || 'EUR';
    if (window.jtFormatMoney) return window.jtFormatMoney(cents);
    var sym = { USD: '$', EUR: '€', GBP: '£', AUD: '$', CAD: '$' }[cur] || '€';
    return sym + (cents / 100).toFixed(2);
  }

  // Giá gạch không có trong /cart.js -> lấy compare_at_price từ /products/<handle>.js (cache theo handle)
  var auCmp = {};
  function auLoadCompare(items) {
    var need = [];
    items.forEach(function (it) {
      if (it.handle && !auCmp[it.handle] && need.indexOf(it.handle) < 0) need.push(it.handle);
    });
    if (!need.length) return Promise.resolve();
    return Promise.all(need.map(function (h) {
      return fetch(auLocalePath('/products/') + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          if (p && p.variants) p.variants.forEach(function (v) { map[v.id] = v.compare_at_price; });
          auCmp[h] = map;
        })
        .catch(function () { auCmp[h] = {}; });
    }));
  }

  function auTruckSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4.2" y="6.6" width="9.1" height="8.1" rx="1.4"/>' +
      '<path d="M14.6 9.1h2.8c.45 0 .87.2 1.15.55l1.65 2.05c.2.25.3.56.3.88v2.2h-5.9z"/>' +
      '<circle cx="8" cy="16.8" r="1.85"/><circle cx="17.2" cy="16.8" r="1.85"/>' +
      '<rect x="0.4" y="8.4" width="3.2" height="1.35" rx=".67" opacity=".5"/>' +
      '<rect x="1.1" y="11.4" width="2.6" height="1.35" rx=".67" opacity=".32"/></svg>';
  }
  function auTrashSvg() {
    return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  }

  // Bong bóng số trên icon giỏ của Horizon. au.js tự fetch /cart/add.js và chặn handler gốc
  // nên Horizon không tự vẽ lại. Cấu trúc ở snippets/cart-bubble.liquid: .cart-bubble mang
  // class visually-hidden khi giỏ rỗng, số nằm trong .cart-bubble__text-count (class hidden khi rỗng).
  function auSyncBubble(count) {
    var has = count > 0;
    document.querySelectorAll('.cart-bubble').forEach(function (bub) {
      bub.classList.toggle('visually-hidden', !has);
      bub.hidden = !has;   /* có nơi dùng thuộc tính hidden, bỏ mỗi class là chưa đủ */
      var num = bub.querySelector('.cart-bubble__text-count');
      if (!num) return;
      num.textContent = count > 99 ? '99+' : String(count);
      num.classList.toggle('hidden', !has);
      num.hidden = !has;
    });
  }

  function auRenderCart() {
    var box = document.getElementById('au-drawer-items');
    if (!box) return;
    fetch(auLocalePath('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
      var displayCount = window.KCPackageCart ? window.KCPackageCart.count(cart.items, document.documentElement.lang) : cart.item_count;
      var inc = auPrevCount !== null && displayCount > auPrevCount;
      document.querySelectorAll('[data-au-cart-count]').forEach(function (el) {
        el.textContent = displayCount;
        el.style.display = cart.item_count > 0 ? '' : 'none';
        el.hidden = cart.item_count <= 0;   /* badge dock dùng thuộc tính hidden, style.display không xoá được */
        if (inc) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
      });
      auSyncBubble(displayCount);
      auPrevCount = displayCount;
      if (!cart.items.length) { auPaintCart(cart, box); return; }
      auLoadCompare(cart.items).then(function () { auPaintCart(cart, box); });
    });
  }

  function auPaintCart(cart, box) {
    var drawer = document.getElementById('au-drawer');
    var totalEl = document.getElementById('au-drawer-total');
    var cntEl = document.querySelector('[data-au-dcount]');
    window.__auLastCart = cart;

    if (cntEl) {
      cntEl.textContent = window.KCPackageCart ? window.KCPackageCart.count(cart.items, document.documentElement.lang) : cart.item_count;
      cntEl.hidden = !cart.item_count;
    }
    // prefill ghi ch\u00fa \u0111\u01a1n
    var noteBox = document.querySelector('[data-dwc-notetext]');
    if (noteBox && document.activeElement !== noteBox) noteBox.value = cart.note || '';

    if (totalEl) totalEl.textContent = auMoney(cart.items_subtotal_price) + (cart.currency ? ' ' + cart.currency : '');
    /* Manta: tổng tiền nằm ngay trong nút CHECKOUT */
    document.querySelectorAll('[data-dwc-co-total]').forEach(function (el) {
      el.textContent = cart.items.length ? auMoney(cart.items_subtotal_price) : '';
    });
    /* Ẩn thẻ mua kèm của sản phẩm đã nằm trong giỏ */
    var inCart = cart.items.map(function (it) { return it.handle; });
    document.querySelectorAll('[data-jt-hp-handle]').forEach(function (card) {
      card.style.display = inCart.indexOf(card.getAttribute('data-jt-hp-handle')) >= 0 ? 'none' : '';
    });
    /* Bảng Initial/Discount/Final + giá gạch trong nút checkout (kiểu Manta) */
    var cmpTotal = 0;
    cart.items.forEach(function (it) {
      var cu = (auCmp[it.handle] || {})[it.variant_id] || 0;
      var line = cu * it.quantity;
      cmpTotal += line > it.final_line_price ? line : it.final_line_price;
    });
    var sumBox = document.querySelector('[data-dwc-sum]');
    var coCmp = document.querySelector('[data-dwc-co-cmp]');
    var hasDisc = cart.items.length && cmpTotal > cart.items_subtotal_price;
    if (sumBox) {
      sumBox.hidden = !hasDisc;
      if (hasDisc) {
        sumBox.querySelector('[data-dwc-sum-init]').textContent = auMoney(cmpTotal);
        sumBox.querySelector('[data-dwc-sum-disc]').textContent = '-' + auMoney(cmpTotal - cart.items_subtotal_price);
        sumBox.querySelector('[data-dwc-sum-final]').textContent = auMoney(cart.items_subtotal_price);
      }
    }
    if (coCmp) {
      coCmp.hidden = !hasDisc;
      coCmp.textContent = hasDisc ? auMoney(cmpTotal) : '';
    }

    // JT: thanh tiến độ freeship
    var fsbar = document.querySelector('[data-jt-fsbar]');
    if (fsbar) {
      // ngưỡng freeship khai bằng EUR (tiền gốc) → quy đổi theo tỷ giá Markets của tiền đang chọn
      var fsRate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      var goal = Math.round((parseInt(fsbar.getAttribute('data-goal'), 10) || 5000) * fsRate);
      var goalEl = fsbar.querySelector('[data-jt-fsbar-goal]');
      if (goalEl) goalEl.textContent = (goalEl.getAttribute('data-pre') || 'Spend') + ' ' + auMoney(goal).replace(/([.,]00)(?=\D*$)/, '');
      var sub = cart.items_subtotal_price;
      fsbar.hidden = !cart.items.length;
      var fill = fsbar.querySelector('[data-jt-fsbar-fill]');
      var txt = fsbar.querySelector('[data-jt-fsbar-text]');
      var pct = Math.min(100, Math.round(sub * 100 / goal));
      if (fill) fill.style.width = pct + '%';
      if (txt) {
        if (sub >= goal) {
          fsbar.classList.add('done');
          txt.textContent = fsbar.getAttribute('data-done');
        } else {
          fsbar.classList.remove('done');
          txt.textContent = (fsbar.getAttribute('data-msg') || '').replace('[amount]', auMoney(goal - sub));
        }
      }
    }

    if (drawer) drawer.classList.toggle('dwc-isempty', !cart.items.length);
    if (!cart.items.length) {
      // giỏ trống kiểu tham chiếu: tiêu đề + câu dẫn + hàng link có mũi tên
      var eT = (drawer && drawer.getAttribute('data-empty')) || 'Your cart is empty.';
      var eM = (drawer && drawer.getAttribute('data-empty-msg')) || '';
      var eL = (drawer && drawer.getAttribute('data-empty-link-label')) || '';
      var eU = (drawer && drawer.getAttribute('data-empty-link')) || '/collections/all';
      box.innerHTML = '<div class="dwc-emptybox">' +
        '<p class="dwc-empty-t">' + eT + '</p>' +
        (eM ? '<div class="dwc-empty-m">' + eM + '</div>' : '') +
        (eL ? '<ul class="dwc-empty-l"><li><a href="' + eU + '"><span>' + eL + '</span>' +
          '<svg viewBox="0 0 21 20" stroke="currentColor" fill="none" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"/></svg>' +
        '</a></li></ul>' : '') +
      '</div>';
      return;
    }

    dwcLoadRecs(cart);
    var rmLabel = (drawer && drawer.getAttribute('data-remove')) || 'Remove';
    var html = '';
    var displayedItems = window.KCPackageCart ? window.KCPackageCart.rows(cart.items, document.documentElement.lang) : cart.items;
    displayedItems.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
      var fl = (it.components || [it]).some(function (part) { return auFlashKeys.indexOf(part.key) >= 0; }) ? ' au-flash' : '';
      /* sao review theo handle (map từ Loox, chỉ có khi review thật) */
      var rate = (window.__jtRates || {})[it.handle];
      var rateHtml = rate ? '<span class="dwc-it-rate"><span class="jt-stars" style="--pct: ' + (rate[0] * 20) + '%"><i></i></span><em>' + rate[1] + ' review' + (rate[1] === 1 ? '' : 's') + '</em></span>' : '';
      /* giá gạch line: compare_at của variant × số lượng + chip Save X% (lime, kiểu Manta) */
      var cmpUnit = (auCmp[it.handle] || {})[it.variant_id] || 0;
      var cmpLine = it.components ? it.components.reduce(function (total, part) { return total + (((auCmp[part.handle] || {})[part.variant_id] || part.final_price || 0) * part.quantity); }, 0) : cmpUnit * it.quantity;
      var hasCmp = cmpLine > it.final_line_price;
      var cmpHtml = hasCmp ? '<s>' + auMoney(cmpLine) + '</s>' : '';
      var pctOff = hasCmp ? Math.round((cmpLine - it.final_line_price) * 100 / cmpLine) : 0;
      var chipSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12.6 2.6 21 11a2 2 0 0 1 0 2.8L13.8 21a2 2 0 0 1-2.8 0L2.6 12.6A2 2 0 0 1 2 11.2V4a2 2 0 0 1 2-2h7.2a2 2 0 0 1 1.4.6Z"/><circle cx="7.6" cy="7.6" r="1.3"/></svg>';
      var chipD = hasCmp ? '<span class="dwc-chip dwc-chip--d">' + chipSvg + pctOff + '%' + auLang(' off', ' de descuento') + '</span>' : '';
      var chipM = hasCmp ? '<span class="dwc-chip dwc-chip--m">' + chipSvg + pctOff + '%' + auLang(' off', ' de descuento') + '</span>' : '';
      html += '<div class="dwc-it' + fl + '" data-key="' + it.key + '">' +
        '<a class="dwc-it-img" href="' + (it.url || '#') + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="dwc-it-mid">' +
          '<div class="dwc-it-top">' +
            rateHtml +
            '<a class="dwc-it-t dwc-rlink" href="' + (it.url || '#') + '">' + it.product_title + '</a>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="dwc-it-v">' + it.variant_title + '</div>' : '') +
            (it.packageDescription ? '<div class="dwc-it-v">' + window.KCPackageCart.escape(it.packageDescription) + '</div>' : '') +
            chipD +
          '</div>' +
        '</div>' +
        '<div class="dwc-it-pr">' + cmpHtml + '<b>' + auMoney(it.final_line_price) + '</b></div>' +
        '<div class="dwc-it-ctl">' +
          '<span class="dwc-qty">' +
            '<button type="button" data-au-dq="-1" aria-label="' + auLang('Decrease', 'Reducir cantidad') + '">&minus;</button>' +
            '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-dwc-qin aria-label="' + auLang('Quantity', 'Cantidad') + '">' +
            '<button type="button" data-au-dq="1" aria-label="' + auLang('Increase', 'Aumentar cantidad') + '">+</button>' +
          '</span>' +
          chipM +
          '<button type="button" class="dwc-rm" data-au-del aria-label="' + rmLabel + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button>' +
        '</div>' +
      '</div>';
    });
    box.innerHTML = html;
    auFlashKeys = [];

    box.querySelectorAll('[data-au-dq]').forEach(function (b) {
      b.addEventListener('click', function () {
        var item = b.closest('.dwc-it');
        var q = parseInt(item.querySelector('[data-dwc-qin]').value, 10) + parseInt(b.getAttribute('data-au-dq'), 10);
        auChangeQty(item.getAttribute('data-key'), Math.max(0, q));
      });
    });
    box.querySelectorAll('[data-dwc-qin]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var q = parseInt(inp.value, 10);
        if (isNaN(q) || q < 0) q = 1;
        auChangeQty(inp.closest('.dwc-it').getAttribute('data-key'), q);
      });
    });
    box.querySelectorAll('[data-au-del]').forEach(function (b) {
      b.addEventListener('click', function () {
        auChangeQty(b.closest('.dwc-it').getAttribute('data-key'), 0);
      });
    });
  }

  // ===== You may also like: lấy động từ /recommendations/products.json (giống trang tham chiếu) =====
  var dwcRecDone = '';   // product_id đã nạp → khỏi gọi lại
  function dwcCardHtml(p, labels) {
    var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
    var vars = p.variants || [];
    var avail = vars.filter(function (v) { return v.available; });
    var varies = vars.length > 1 && vars.some(function (v) { return v.price !== vars[0].price; });
    var plusSvg = '<svg viewBox="0 0 12 12" stroke="currentColor" fill="none" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.5 6H6M9.5 6H6M6 6V2.5M6 6V9.5"/></svg>';
    var cta = '';
    if (vars.length > 1) {
      cta = '<a class="dwc-hpbtn dwc-hb dwc-hb-p" href="' + p.url + '">' +
        '<span class="dwc-fill" aria-hidden="true"></span>' +
        '<span class="dwc-btntxt">' + plusSvg + '<span class="dwc-hpbl">' + labels.view + '</span></span></a>';
    } else if (avail.length) {
      cta = '<button type="button" class="dwc-hpbtn dwc-hb dwc-hb-p" data-dwc-add="' + avail[0].id + '" aria-label="' + auLang('Add', 'Añadir') + '">' +
        '<span class="dwc-fill" aria-hidden="true"></span>' +
        '<span class="dwc-btntxt">' + plusSvg + '<span class="dwc-hpbl">' + labels.add + '</span></span></button>';
    }
    return '<div class="dwc-hp">' +
      '<a class="dwc-hp-img" href="' + p.url + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="dwc-hp-mid">' +
        '<a class="dwc-hp-t dwc-rlink" href="' + p.url + '">' + p.title + '</a>' +
        '<div class="dwc-hp-p">' + (varies ? '<small>' + labels.from + '</small> ' : '') + '<span>' + auMoney(p.price) + '</span></div>' +
      '</div>' +
      '<div class="dwc-hp-cta">' + cta + '</div>' +
    '</div>';
  }

  function dwcLoadRecs(cart) {
    var box = document.querySelector('.dwc-ups[data-dwc-auto]');
    if (!box || !cart.items.length) return;
    var pid = cart.items[0].product_id;
    if (!pid || dwcRecDone === String(pid)) return;
    dwcRecDone = String(pid);
    var panel = document.getElementById('au-drawer');
    var labels = {
      add: (panel && panel.getAttribute('data-add-label')) || 'Add',
      view: (panel && panel.getAttribute('data-view-label')) || 'View',
      from: (panel && panel.getAttribute('data-from-label')) || 'From'
    };
    var intent = (panel && panel.getAttribute('data-rec-intent')) || 'related';
    fetch(auLocalePath('/recommendations/products.json?product_id=') + pid + '&limit=5&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var list = (json && json.products) || [];
        // bỏ sản phẩm đã có trong giỏ
        var inCart = cart.items.map(function (it) { return it.product_id; });
        list = list.filter(function (p) { return inCart.indexOf(p.id) < 0; });
        if (!list.length) { box.hidden = true; return; }
        var track = box.querySelector('[data-dwc-track]');
        track.innerHTML = list.map(function (p) { return dwcCardHtml(p, labels); }).join('');
        box.hidden = false;
        var next = box.querySelector('[data-dwc-next]');
        if (next) next.disabled = list.length < 2;
        dwcWireTrack(box);
      })
      .catch(function () { dwcRecDone = ''; });
  }

  function auChangeQty(key, qty) {
    if (window.KCPackageCart) {
      window.KCPackageCart.change(key, qty).then(function (cart) {
        var box = document.getElementById('au-drawer-items');
        if (box) auPaintCart(cart, box);
        auRenderCart();
      }).catch(function (error) {
        fetch(auLocalePath('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
          auPaintCart(cart, document.getElementById('au-drawer-items'));
          window.KCPackageCart.showError(error);
        }).catch(function () { window.KCPackageCart.showError(error); });
      });
      return;
    }
    fetch(auLocalePath('/cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { auRenderCart(); });
  }

  function auOpenDrawer(flashKeys) {
    if (!auDrawer) return;
    if (flashKeys) auFlashKeys = flashKeys;
    auRenderCart();
    auDrawer.classList.add('show');
    if (auDrawerOv) auDrawerOv.classList.add('show');
    document.documentElement.style.overflow = 'hidden';
  }
  function auCloseDrawer() {
    if (auDrawer) auDrawer.classList.remove('show');
    if (auDrawerOv) auDrawerOv.classList.remove('show');
    document.documentElement.style.overflow = '';
  }
  // JT: expose cho jt.js (buybox bundle tự POST /cart/add.js rồi mở drawer này)
  window.auOpenDrawer = auOpenDrawer;
  window.auRenderCart = function () { auRenderCart(); };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') auCloseDrawer(); });

  // Wiring có guard class + re-init (Horizon morph DOM sau load làm rơi listener)
  function auWireCart() {
    auDrawer = document.getElementById('au-drawer');
    auDrawerOv = document.getElementById('au-drawer-ov');
    if (auDrawerOv && !auDrawerOv.classList.contains('au-wired')) {
      auDrawerOv.classList.add('au-wired');
      auDrawerOv.addEventListener('click', auCloseDrawer);
    }
    var closeBtn = document.getElementById('au-drawer-close');
    if (closeBtn && !closeBtn.classList.contains('au-wired')) {
      closeBtn.classList.add('au-wired');
      closeBtn.addEventListener('click', auCloseDrawer);
    }

  // ===== Mở giỏ từ icon header + chặn form ATC (gộp gói bảo hành) + tự nối lại listener  [nguồn au.js 302-349] =====
    document.querySelectorAll('[data-au-cart-open]:not(.au-wired)').forEach(function (a) {
      a.classList.add('au-wired');
      a.addEventListener('click', function (e) {
        if (!document.getElementById('au-drawer')) return; // không có drawer → về /cart như thường
        e.preventDefault();
        auOpenDrawer();
      });
    });
    // Icon giỏ trên header Horizon (on:click="#cart-drawer/toggle") → chặn, mở drawer clone.
    // Delegation của Horizon đọc thuộc tính on:click lúc sự kiện nổ → gỡ thuộc tính mỗi lượt wire
    // (Horizon morph DOM có thể trả lại attribute nên không nấp sau guard .au-wired).
    document.querySelectorAll('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]').forEach(function (b) {
      if (document.getElementById('au-drawer')) b.removeAttribute('on:click');
      if (b.classList.contains('au-wired')) return;
      b.classList.add('au-wired');
      b.addEventListener('click', function (e) {
        if (!document.getElementById('au-drawer')) return;
        e.preventDefault();
        e.stopImmediatePropagation(); // chặn toggle drawer mặc định của Horizon
        auOpenDrawer();
      }, true);
    });
    // Intercept mọi form add-to-cart (buybox + warranty combo, tips "+", v.v.)
    document.querySelectorAll('.au form[action*="/cart/add"]:not(.au-atc-wired)').forEach(function (form) {
      form.classList.add('au-atc-wired');
      form.addEventListener('submit', function (e) {
        if (!document.getElementById('au-drawer')) return; // fallback: submit thường
        e.preventDefault();
        e.stopImmediatePropagation(); // chặn handler tự-add của Horizon (product-form) → tránh add trùng
        var btn = form.querySelector('button[type="submit"]');
        var lab = btn ? auLabelOf(btn) : null;
        var old = lab ? lab.textContent : '';
        if (btn) { btn.disabled = true; lab.textContent = btn.getAttribute('data-adding') || 'ADDING…'; }
        var wBox = document.querySelector('[data-au-warranty]');
        var req;
        if (form.getAttribute('id') === 'au-atc-form' && wBox && wBox.value && wBox.checked) {
          // Warranty checked: thêm sản phẩm chính + gói bảo hành cùng lúc
          var mainVid = form.querySelector('[name="id"]').value;
          req = fetch(auLocalePath('/cart/add.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [ { id: Number(mainVid), quantity: 1 }, { id: Number(wBox.value), quantity: 1 } ] })
          });
        } else {
          req = fetch(auLocalePath('/cart/add.js'), { method: 'POST', body: new FormData(form) });
        }
        req.then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
          .then(function (json) {
            var keys = [];
            if (json) { if (json.items) json.items.forEach(function (x) { if (x.key) keys.push(x.key); }); else if (json.key) keys.push(json.key); }
            if (btn) auShowTick(btn);
            setTimeout(function () {
              auOpenDrawer(keys);
              if (btn) { btn.disabled = false; btn.classList.remove('au-added'); lab.textContent = old; }
            }, 480);
          })
          .catch(function () { if (btn) { btn.disabled = false; lab.textContent = old; } form.classList.remove('au-atc-wired'); form.submit(); }); // lỗi → fallback submit thường
      }, true); // capture phase → chạy trước handler Horizon
    });
  }
  // 2 mũi tên carousel gợi ý (gọi lại được sau khi đổ card động)
  function dwcWireTrack(scope) {
    var track = scope.querySelector('[data-dwc-track]');
    var prev = scope.querySelector('[data-dwc-prev]');
    var next = scope.querySelector('[data-dwc-next]');
    if (!track || !prev || !next) return;
    function upd() {
      prev.disabled = track.scrollLeft < 10;
      next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 10;
    }
    if (!track.__dwcWired) {
      track.__dwcWired = true;
      prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth - 40, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth + 40, behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
    }
    if (track.children.length > 1) upd();
  }

  // ===== Drawer v2: tab, tiện ích (note/ship/discount), gợi ý, recently viewed =====
  function dwcWire() {
    var panel = document.getElementById('au-drawer');
    if (!panel || panel.classList.contains('dwc-wired')) return;
    panel.classList.add('dwc-wired');

    // tab Cart / Recently viewed
    var tabs = panel.querySelectorAll('[data-dwc-tab]');
    var views = panel.querySelectorAll('[data-dwc-view]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('on', x === t); });
        views.forEach(function (v) { v.classList.toggle('on', v.getAttribute('data-dwc-view') === t.getAttribute('data-dwc-tab')); });
        if (t.getAttribute('data-dwc-tab') === 'rv') dwcPaintRv();
      });
    });

    // hàng tiện ích: bấm nút nào mở panel đó (bấm lại thì đóng)
    panel.querySelectorAll('[data-dwc-util]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-dwc-util');
        panel.querySelectorAll('[data-dwc-upanel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-dwc-upanel') === k ? !p.hidden : true;
        });
      });
    });

    // lưu ghi chú đơn
    var noteSave = panel.querySelector('[data-dwc-notesave]');
    if (noteSave) noteSave.addEventListener('click', function () {
      var v = (panel.querySelector('[data-dwc-notetext]') || {}).value || '';
      noteSave.disabled = true;
      fetch(auLocalePath('/cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) })
        .then(function () { noteSave.disabled = false; panel.querySelector('[data-dwc-upanel="note"]').hidden = true; });
    });

    // mã giảm: gắn vào link checkout, checkout sẽ tự áp
    var disc = panel.querySelector('[data-dwc-disc]');
    var co = panel.querySelector('[data-dwc-checkout]');
    var coBase = co ? co.getAttribute('href') : '';
    function applyDisc(code) {
      if (!co) return;
      co.setAttribute('href', code ? coBase + '?discount=' + encodeURIComponent(code) : coBase);
      try { localStorage.setItem('dw_disc', code || ''); } catch (e) {}
    }
    if (disc) {
      try { disc.value = localStorage.getItem('dw_disc') || ''; } catch (e) {}
      if (disc.value) applyDisc(disc.value.trim());
      var ap = panel.querySelector('[data-dwc-discapply]');
      if (ap) ap.addEventListener('click', function () {
        applyDisc(disc.value.trim());
        panel.querySelector('[data-dwc-upanel="disc"]').hidden = true;
      });
    }

    // carousel gợi ý
    dwcWireTrack(panel);

    // nút + thêm nhanh (gợi ý + recently viewed — nghe ủy quyền vì RV render sau)
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dwc-add]');
      if (!b) return;
      b.disabled = true;
      fetch(auLocalePath('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(b.getAttribute('data-dwc-add')), quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.key) auFlashKeys = [json.key];
          b.disabled = false;
          var cartTab = panel.querySelector('[data-dwc-tab="cart"]');
          if (cartTab) cartTab.click();
          auRenderCart();
        })
        .catch(function () { b.disabled = false; });
    });
  }

  // Recently viewed: lưu handle sản phẩm đã xem, render trong tab 2
  (function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    try {
      var list = JSON.parse(localStorage.getItem('dw_rv') || '[]').filter(function (h) { return h !== m[1]; });
      list.unshift(m[1]);
      localStorage.setItem('dw_rv', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  })();

  function dwcPaintRv() {
    var box = document.querySelector('[data-dwc-rv]');
    if (!box) return;
    var cur = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    var list = [];
    try { list = JSON.parse(localStorage.getItem('dw_rv') || '[]'); } catch (e) {}
    list = list.filter(function (h) { return h !== cur; });
    if (!list.length) { box.innerHTML = '<div class="dwc-empty">' + (box.getAttribute('data-empty') || '') + '</div>'; return; }
    box.innerHTML = '';
    Promise.all(list.slice(0, 6).map(function (h) {
      return fetch(auLocalePath('/products/') + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var addLabel = (document.getElementById('au-drawer') || { getAttribute: function () {} }).getAttribute('data-add-label') || 'Add';
      var plusSvg = '<svg viewBox="0 0 12 12" stroke="currentColor" fill="none" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.5 6H6M9.5 6H6M6 6V2.5M6 6V9.5"/></svg>';
      var html = '';
      ps.filter(Boolean).forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
        html += '<div class="dwc-hp dwc-hp-rv">' +
          '<a class="dwc-hp-img" href="/products/' + p.handle + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="dwc-hp-mid">' +
            '<a class="dwc-hp-t dwc-rlink" href="/products/' + p.handle + '">' + p.title + '</a>' +
            '<div class="dwc-hp-p"><span>' + auMoney(p.price) + '</span></div>' +
          '</div>' +
          (v ? '<div class="dwc-hp-cta"><button type="button" class="dwc-hpbtn dwc-hb dwc-hb-p" data-dwc-add="' + v.id + '" aria-label="' + auLang('Add', 'Añadir') + '">' +
            '<span class="dwc-fill" aria-hidden="true"></span>' +
            '<span class="dwc-btntxt">' + plusSvg + '<span class="dwc-hpbl">' + addLabel + '</span></span>' +
          '</button></div>' : '') +
        '</div>';
      });
      box.innerHTML = html || '<div class="dwc-empty">' + (box.getAttribute('data-empty') || '') + '</div>';
    });
  }

  auWireCart();
  dwcWire();
  setTimeout(auWireCart, 1200);
  setTimeout(auWireCart, 2600);
  new MutationObserver(function () { auWireCart(); dwcWire(); }).observe(document.body, { childList: true, subtree: true });

  // ===== Cờ giảm chuyển động / máy bàn  [nguồn au.js 370-371] =====
  var auReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var auDesktop = !window.matchMedia || window.matchMedia('(min-width: 1024px)').matches;

  // ===== Cuộn mượt tới anchor + ảnh hiện dần khi load  [nguồn au.js 464-500] =====
  // (11) Smooth-scroll cho anchor trong trang (Horizon cuộn .page-wrapper trên desktop)
  document.querySelectorAll('.au a[href^="#"]').forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href === '#' || a.hasAttribute('data-au-cart-open')) return;
    a.addEventListener('click', function (e) {
      var tgt = document.getElementById(href.slice(1));
      if (!tgt) return;
      e.preventDefault();
      // Section đích chỉnh điểm đáp qua --au-anchor-off (âm = cuộn sâu hơn, mặc định 20px cách mép trên)
      var off = parseFloat(getComputedStyle(tgt).getPropertyValue('--au-anchor-off'));
      if (isNaN(off)) off = 20;
      // PC: thanh sticky PDP nằm ĐÈ trên đầu màn hình → phải chừa đúng chiều cao của nó,
      // không thì tiêu đề khối vừa cuộn tới đã bị che (mobile thanh nằm dưới đáy nên bỏ qua).
      var auStk = document.querySelector('.pdp-sticky');
      if (auStk && window.matchMedia('(min-width: 1024px)').matches) {
        off += Math.round(auStk.getBoundingClientRect().height) || 0;
      }
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4) {
        pw.scrollTo({ top: tgt.getBoundingClientRect().top - pw.getBoundingClientRect().top + pw.scrollTop - off, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: tgt.getBoundingClientRect().top + (window.pageYOffset || 0) - off, behavior: 'smooth' });
      }
    });
  });

  // (12) Blur-up khi ảnh load (bỏ qua ảnh đã sẵn để không nháy LCP)
  document.querySelectorAll('.au img').forEach(function (img) {
    if (img.closest('.au-drawer')) return;
    if (img.complete && img.naturalWidth > 0) return;
    img.classList.add('au-blur');
    if (img.complete) { img.classList.add('au-loaded'); }
    else {
      img.addEventListener('load', function () { img.classList.add('au-loaded'); });
      img.addEventListener('error', function () { img.classList.add('au-loaded'); });
    }
  });

  // ===== Hiệu ứng PDP: zoom gallery theo chuột, giá bảo hành đếm, thanh sticky ẩn khi cuộn lên  [nguồn au.js 502-565] =====
  // ============================================================
  // FX — PDP
  // ============================================================

  // (P1) Gallery zoom-follow (desktop, hover)
  if (!auReduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('[data-au-zoom]').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;
      wrap.addEventListener('mousemove', function (e) {
        var r = wrap.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      });
      wrap.addEventListener('mouseenter', function () { wrap.classList.add('zooming'); });
      wrap.addEventListener('mouseleave', function () { wrap.classList.remove('zooming'); img.style.transformOrigin = ''; });
    });
  }

  // (P3) Warranty: giá đếm trượt + hàng sáng lên
  (function () {
    var wb = document.querySelector('[data-au-warranty]');
    var nowEl = document.querySelector('.atc-price .now');
    if (!wb || !nowEl) return;
    var row = wb.closest('.warranty-row');
    var priceB = row ? row.querySelector('b') : null;
    var readNum = function (el, fb) { return parseFloat(((el && el.textContent || '').match(/[\d.]+/) || [fb])[0]) || fb; };
    var base = readNum(nowEl, 0);
    var wPrice = readNum(priceB, 0);
    if (!base || !wPrice) return;
    function fmt(v) { if (window.jtFormatMoney) return window.jtFormatMoney(Math.round(v * 100)); return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
    function animTo(target) {
      var from = parseFloat(((nowEl.textContent || '').match(/[\d.]+/) || [base])[0]);
      if (auReduce) { nowEl.textContent = fmt(target); return; }
      var t0 = null, dur = 380;
      nowEl.classList.add('pricing');
      function step(ts) {
        if (!t0) t0 = ts;
        var pgs = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - pgs, 3);
        nowEl.textContent = fmt(from + (target - from) * e);
        if (pgs < 1) requestAnimationFrame(step);
        else setTimeout(function () { nowEl.classList.remove('pricing'); }, 250);
      }
      requestAnimationFrame(step);
    }
    wb.addEventListener('change', function () {
      if (row) row.classList.toggle('w-on', wb.checked);
      animTo(wb.checked ? base + wPrice : base);
    });
    // Đổi gói / đổi màu -> bộ chọn biến thể vừa ghi giá mới vào nowEl, đọc lại làm gốc
    document.addEventListener('au:variant', function () {
      base = readNum(nowEl, base);
      if (wb.checked) animTo(base + wPrice);
    });
  })();

  // (P4) Sticky bar: ẩn khi cuộn lên, hiện lại khi cuộn xuống
  (function () {
    var stickyEl = document.getElementById('pdpSticky');
    if (!stickyEl) return;
    var lastY = -1;
    function onScroll() {
      var pw = document.querySelector('.page-wrapper');
      var y = (pw && pw.scrollHeight > pw.clientHeight + 4) ? pw.scrollTop : (window.pageYOffset || document.documentElement.scrollTop);
      if (lastY >= 0 && Math.abs(y - lastY) > 6) stickyEl.classList.toggle('au-dirup', y < lastY);
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var pw2 = document.querySelector('.page-wrapper');
    if (pw2) pw2.addEventListener('scroll', onScroll, { passive: true });
  })();

  // ===== Gallery ghim: điểm ghim tự né các thanh dính trên đỉnh =====
  // Header Horizon là sticky cao ~65px; ghim ảnh ở 24px là chui xuống dưới nó.
  // Đo đáy của mọi thanh đang che mép trên (header + thanh sticky PDP) rồi cộng khe cấu hình.
  (function () {
    var g = document.querySelector('.gal-sticky');
    if (!g) return;
    var gap = parseFloat(g.style.getPropertyValue('--au-gal-gap')) || 24;
    var tick = false;
    function upd() {
      tick = false;
      var top = gap;
      ['header.shopify-section', '#pdpSticky'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0 && r.bottom < window.innerHeight / 2) top = Math.max(top, r.bottom + gap);
      });
      g.style.setProperty('--au-gal-top', top + 'px');
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    var pwg = document.querySelector('.page-wrapper');
    if (pwg) pwg.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    upd();
  })();
})();
